import { MonitoringTextStyleModel } from './monitoring-text-style.model';
import { BriefingStyleStateEnum } from '../../../Common/MonitorShared/enum/briefing-style-state.enum';

export class MonitoringTitleStyleModel extends MonitoringTextStyleModel {
    headingTwo: MonitoringTextStyleModel;
    headingThree: MonitoringTextStyleModel;

    constructor(apiModel?: any) {
        super(apiModel);

        if (apiModel) {
            this.setFromApiModel(apiModel);
        } else {
            this.headingTwo = new MonitoringTextStyleModel();
            this.headingThree = new MonitoringTextStyleModel();
        }
    }

    clone(): MonitoringTitleStyleModel {
        const clone = new MonitoringTitleStyleModel(
            {
                color: this.color,
                fontFamily: this.fontFamily,
                fontSize: this.fontSize,
                bold: this.bold,
                italics: this.italics,
                underlined: this.underlined,
                alignment: this.alignment,
                styleState: this.styleState,
                displayStyleState: this.displayStyleState,
                defaultReference: this.defaultReference ? this.defaultReference : BriefingStyleStateEnum.BRIEFING_1,
                backgroundColor: this.backgroundColor,
                padding: this.padding,

                headingTwo: this.headingTwo,
                headingThree: this.headingThree,
            }
        );

        if (this.template) {
            clone.template = this.template.clone();
        }

        return clone;
    }

    toBlockStyle(): any {
        if (!this.isSavedStyle()) {
            return {
                color: this.color,
                fontFamily: this.fontFamily,
                fontSize: this.fontSize,
                bold: this.bold,
                italics: this.italics,
                underlined: this.underlined,
                alignment: this.alignment,
                styleState: this.styleState,
                displayStyleState: this.displayStyleState,
                backgroundColor: this.backgroundColor,
                padding: this.padding,

                headingTwo: this.headingTwo,
                headingThree: this.headingThree,
            };
        } else {
            return {
                styleState: this.styleState
            };
        }
    }

    toApi(): any {
        return {
            color: this.color,
            fontFamily: this.fontFamily,
            fontSize: this.fontSize,
            bold: this.bold,
            italics: this.italics,
            underlined: this.underlined,
            alignment: this.alignment,
            defaultReference: this.defaultReference ? this.defaultReference : BriefingStyleStateEnum.BRIEFING_1,
            backgroundColor: this.backgroundColor,
            padding: this.padding,

            headingTwo: this.headingTwo,
            headingThree: this.headingThree,
        };
    }

    setFromApiModel(apiModel: any): void {
        super.setFromApiModel(apiModel);

        if (typeof apiModel === 'string') {
            apiModel = JSON.parse(apiModel);
        }

        if (apiModel.hasOwnProperty('headingTwo')) {
            this.headingTwo = new MonitoringTextStyleModel(apiModel.headingTwo);
        } else {
            this.headingTwo = new MonitoringTextStyleModel();
            if (!this.headingTwo.color && this.color) {
                this.headingTwo.color = this.color;
            }
            if (!this.headingTwo.fontFamily && this.fontFamily) {
                this.headingTwo.fontFamily = this.fontFamily;
            }
            if (!this.headingTwo.fontSize && this.fontSize) {
                this.headingTwo.fontSize = this.fontSize;
            }
            if (!this.headingTwo.bold && this.bold) {
                this.headingTwo.bold = this.bold;
            }
            if (!this.headingTwo.italics && this.italics) {
                this.headingTwo.italics = this.italics;
            }
            if (!this.headingTwo.underlined && this.underlined) {
                this.headingTwo.underlined = this.underlined;
            }
            if (!this.headingTwo.alignment && this.alignment) {
                this.headingTwo.alignment = this.alignment;
            }
            if (!this.headingTwo.backgroundColor && this.backgroundColor) {
                this.headingTwo.backgroundColor = this.backgroundColor;
            }
            if (!this.headingTwo.padding && this.padding) {
                this.headingTwo.padding = this.padding;
            }
        }
        if (apiModel.hasOwnProperty('headingThree')) {
            this.headingThree = new MonitoringTextStyleModel(apiModel.headingThree);
        } else {
            this.headingThree = new MonitoringTextStyleModel();
            if (!this.headingThree.color && this.color) {
                this.headingThree.color = this.color;
            }
            if (!this.headingThree.fontFamily && this.fontFamily) {
                this.headingThree.fontFamily = this.fontFamily;
            }
            if (!this.headingThree.fontSize && this.fontSize) {
                this.headingThree.fontSize = this.fontSize;
            }
            if (!this.headingThree.bold && this.bold) {
                this.headingThree.bold = this.bold;
            }
            if (!this.headingThree.italics && this.italics) {
                this.headingThree.italics = this.italics;
            }
            if (!this.headingThree.underlined && this.underlined) {
                this.headingThree.underlined = this.underlined;
            }
            if (!this.headingThree.alignment && this.alignment) {
                this.headingThree.alignment = this.alignment;
            }
            if (!this.headingThree.backgroundColor && this.backgroundColor) {
                this.headingThree.backgroundColor = this.backgroundColor;
            }
            if (!this.headingThree.padding && this.padding) {
                this.headingThree.padding = this.padding;
            }
        }
    }


    /**
     * Compares two MonitoringTitleStyleModels for equality
     */
    equals(
        other: MonitoringTitleStyleModel,
        compareTemplate: boolean,
        compareGenericStyles: boolean = true
    ): boolean {
        if (other === null || other === undefined) {
            return false;
        }
        if (compareGenericStyles && !super.equals(other, compareTemplate)) {
            return false;
        }

        if (!this.headingTwo.equals(other.headingTwo, compareTemplate)) {
            return false;
        }
        if (!this.headingThree.equals(other.headingThree, compareTemplate)) {
            return false;
        }

        return true;
    }
}
